import type { FC } from 'react';
import React from 'react';
import type { MessageDescriptor } from 'react-intl';
import { FormattedMessage } from 'react-intl';

import AkDropdownItem from '@atlaskit/dropdown-menu/dropdown-menu-item';

type SortByDropdownClickItemProps = {
	msg: MessageDescriptor;
	onClick: () => void;
};

export const SortByDropdownClickItem: FC<SortByDropdownClickItemProps> = ({ msg, onClick }) => (
	<AkDropdownItem onClick={onClick}>
		<FormattedMessage {...msg} key={msg.id} />
	</AkDropdownItem>
);
